/* eslint-disable prefer-rest-params */
import { AxiosResponse } from 'axios';
import { EditCollectionSettings } from '../../../mutations/widgets/collections';
import axios, { handleUnauthorized } from '../../axios';
import { API_ROUTES } from '../../../constants/app';
import { Command } from '../../../types/commands';
import { CollectionLayoutOptions } from '../../../types/widgets/collections';

export async function addNewCollectionWidgetToSectionApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  guideVersion: number,
  collectionId: string,
  collectionSettings: EditCollectionSettings,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.ADD_NEW_COLLECTION_WIDGET_TO_SECTION,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        widgetCollectionPayload: {
          collectionId,
          collectionSettings,
        },
      },
    })
    .catch(error =>
      handleUnauthorized(
        error,
        addNewCollectionWidgetToSectionApi,
        ...arguments,
      ),
    );
}

export async function editCollectionWidgetApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  guideVersion: number,
  collectionId: string,
  layout: CollectionLayoutOptions,
  showAssetTitle: boolean,
  assetsShown: number,
  showAssetType: boolean,
  showAssetDownload: boolean,
  showCollectionDownload: boolean,
  allowAssetRedirection: boolean,
  allowCollectionRedirection: boolean,
  showOpenAssetInAssetBank: boolean,
): Promise<AxiosResponse> {
  return (await axios()).post(API_ROUTES.GUIDES_WRITE, {
    command: Command.EDIT_COLLECTION_WIDGET,
    aggregateId: guideId,
    aggregateVersion: guideVersion,
    payload: {
      chapterId,
      pageId,
      sectionId,
      widgetId,
      columnIndex,
      widgetCollectionPayload: {
        collectionId,
        collectionSettings: {
          layout,
          showAssetTitle,
          assetsShown,
          showAssetType,
          showAssetDownload,
          showCollectionDownload,
          allowAssetRedirection,
          allowCollectionRedirection,
          showOpenAssetInAssetBank,
        },
      },
    },
  });
}
export async function editCollectionStyleApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  guideVersion: number,
  style: string,
): Promise<AxiosResponse> {
  return (await axios()).post(API_ROUTES.GUIDES_WRITE, {
    command: Command.EDIT_STYLE_IN_COLLECTION_WIDGET,
    aggregateId: guideId,
    aggregateVersion: guideVersion,
    payload: {
      chapterId,
      pageId,
      sectionId,
      widgetId,
      columnIndex,
      widgetCollectionPayload: {
        style: {
          stylesheet: style,
          language: 'css',
          version: 3,
        },
      },
    },
  });
}
